import React from 'react';
import { Icon, IconEnum } from '@investoro/core';
import styled from 'styled-components';
import type { AiSummarySectionDto } from 'utils/types/AiPredictorModels';

import { SectionHeader, SectionTitle } from 'components/valuation/common';

const AiSummaryCard = styled.div`
    width: 100%;
    background: var(--background-color-ai);
    border-radius: var(--box-border-radius);
    padding: 24px 30px;
    border-left: 4px solid var(--color-alt);

    @media (max-width: 768px) {
        padding: 20px;
    }
`;

const AiSummaryText = styled.p`
    font-size: var(--font-size-body-1);
    font-weight: 500;
    color: var(--color-primary);
    line-height: 1.7;
    margin: 0;
`;

interface ValuationAiSummaryProps {
    section: AiSummarySectionDto;
}

const ValuationAiSummary = ({ section }: ValuationAiSummaryProps) => {
    if (!section.aiRecommendationText) return null;

    return (
        <AiSummaryCard>
            <SectionHeader>
                <Icon icon={IconEnum.AI_STARS} />
                <SectionTitle>Podsumowanie AI</SectionTitle>
            </SectionHeader>
            <AiSummaryText>{section.aiRecommendationText}</AiSummaryText>
        </AiSummaryCard>
    );
};

export default ValuationAiSummary;
